import React, { useEffect, useState } from "react";
import styles from "./FAQ.module.css";
import { Collapse, Skeleton } from "antd";
import { TextComponent } from "../../../components";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { PagesMiddleware } from "../../../Store/Middlewares/PagesMiddleware";
const FAQ = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.AuthReducer.user);
  const pages = useSelector((state) => state.PagesReducer.pages);
  const dispatch = useDispatch();

  console.log(user);

  useEffect(() => {
    setLoading(true);
    dispatch(PagesMiddleware.getPages({ role: user?.type }))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);
  const panelStyle = {
    marginBottom: "20px",
    background: "var(--white-color)",
    borderRadius: "10px",
    border: "none",
    padding: "10px",
  };
  // const items = (panelStyle) => [
  //   {
  //     key: "1",
  //     label: (
  //       <TextComponent
  //         text={"How do I reset my password?"}
  //         className={styles.label}
  //       />
  //     ),
  //     children: (
  //       <TextComponent
  //         className={styles.children}
  //         text={
  //           "If you don’t receive the reset email within a few minutes, please check your spam/junk folder or contact our support team for assistance."
  //         }
  //       />
  //     ),
  //     style: panelStyle,
  //   },
  //   {
  //     key: "2",
  //     label: (
  //       <TextComponent
  //         text={"how to register a module"}
  //         className={styles.label}
  //       />
  //     ),
  //     children: (
  //       <TextComponent
  //         className={styles.children}
  //         text={
  //           ":If you don’t receive the reset email within a few minutes, please check your spam/junk folder or contact our support team for assistance."
  //         }
  //       />
  //     ),
  //     style: panelStyle,
  //   },
  //   {
  //     key: "3",
  //     label: (
  //       <TextComponent
  //         text={"Can I update or delete my account information?"}
  //         className={styles.label}
  //       />
  //     ),
  //     children: (
  //       <TextComponent
  //         className={styles.children}
  //         text={
  //           ":If you don’t receive the reset email within a few minutes, please check your spam/junk folder or contact our support team for assistance."
  //         }
  //       />
  //     ),
  //     style: panelStyle,
  //   },
  // ];
  const items = pages?.faqs?.map((faq, index) => ({
    key: `${index + 1}`,
    label: <TextComponent text={faq?.title} className={styles.title} />,
    children: (
      <TextComponent className={styles.children} text={faq?.description} />
    ),
    style: panelStyle,
  }));
  return (
    <div className={styles.mainCont}>
      <Skeleton loading={loading} active paragraph={{ rows: 10 }}>
        <Collapse
          items={items}
          className={styles.panel}
          expandIcon={({ isActive }) =>
            isActive ? (
              <FiMinusCircle color="var(--secondary-color)" size={18} />
            ) : (
              <FiPlusCircle color="var(--secondary-color)" size={18} />
            )
          }
          expandIconPosition="right"
          defaultActiveKey={["1"]}
          style={{
            background: "var(--bg-color)",
            borderRadius: 0,
            border: "none",
          }}
        />
      </Skeleton>
    </div>
  );
};

export default FAQ;
